const ROUTES = {
  DETAILS: "DETAILS",
};

export { ROUTES };
